<template>
    <div>
        <bulk-selection-bar :items="assets"
                            class="mb-3"
                            v-model="assetSelection"
                            :bulk-action-running="bulkActionRunning">
            <template v-slot:menuSlot>
                <b-button variant="outline"
                          @click="handleRemoveAssetsFromCollection">
                    Remove From This Collection
                </b-button>
<!--                <b-dropdown variant="outline"-->
<!--                            right-->
<!--                            menu-class="dropdown-menu-projects"-->
<!--                            text="Add to Collection"-->
<!--                            @shown="$refs.collectionDropdown.fetchCollections()"-->
<!--                            :disabled="bulkActionRunning">-->
<!--                    <collection-dropdown :bulk-action-running="bulkActionRunning"-->
<!--                                         :url="collectionsUrl"-->
<!--                                         ref="collectionDropdown"-->
<!--                                         @addToCollection="handleAddAssets"/>-->
<!--                </b-dropdown>-->

            </template>
        </bulk-selection-bar>

        <div class="card">
            <div class="card-body">
                <modal-navigation :assets="assets"
                                  :tag-category-priority="tagCategoryPriority"
                                  ref="modalNavigation"/>

                <b-row cols-lg="3" cols-md="2" cols="1" no-gutters
                       class="align-items-stretch">
                    <b-col v-for="asset in assets"
                           class="p-1 asset-avatar-select-overlay d-flex flex-column"
                           :key="assetKey(asset)">
                        <div class="img-bg text-white asset-square-item-image bottom-actions-hover-trigger asset-avatar-overlay-container"
                             :style="backgroundImage(asset)">

                            <div class="asset-avatar-overlay"/>

                            <div @click.prevent.stop="handleAssetSelection(asset)"
                                 class="image-select-control"
                                 :class="{ 'selection-area-expanded': selectedAssetsCount > 0 }">
                                <b-form-checkbox v-model="assetSelection[asset.id]" @click.stop/>
                            </div>

                            <div class="d-flex bottom-actions align-items-center justify-content-end">
                                <div class="d-flex align-items-center">
                                    <b-button class="p-0 mr-1 bottom-actions-hover"
                                              variant="transparent"
                                              @click.stop="handleAssetClick(asset)"
                                              v-b-tooltip
                                              title="Preview">
                                        <i class="fas fa-search-plus text-white text-shadow-sm"></i>
                                    </b-button>

                                    <b-button class="p-0 mr-1"
                                              :class="{'bottom-actions-hover': assetPreviewId !== asset.id}"
                                              variant="transparent"
                                              @click.stop="updateAssetPreviewId(asset.id)"
                                              v-b-tooltip
                                              title="Collection Preview Image">
                                        <i class="fa-star text-white text-shadow-sm" :class="{'far': assetPreviewId !== asset.id, 'fas': assetPreviewId === asset.id}"></i>
                                    </b-button>

<!--                                    <move-to-collection :collections-url="collectionsUrl"-->
<!--                                                        button-class="p-0 mr-1 bottom-actions-hover"-->
<!--                                                        :collection-assets-url="collectionAssetsUrl"-->
<!--                                                        :asset-id="asset.id">-->
<!--                                        <template slot="button-slot">-->
<!--                                            <i class="fas fa-folder-open text-white text-shadow-sm"/>-->
<!--                                        </template>-->
<!--                                    </move-to-collection>-->

                                </div>
                            </div>
                        </div>

                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import GeneralMixins from '../../../mixins/GeneralMixins'
import ModalNavigation from "../../Common/ModalNavigation"
import BulkSelectionBar from "../../Common/BulkSelectionBar";
import CollectionDropdown from "./CollectionDropdown";
import MoveToCollection from "./MoveToCollection";
import CollectionMixins from "./CollectionMixins";

export default {
  props: [
    'assets',
    'collection',
    'tagCategoryPriority',
    'collectionsUrl',
    'collectionAssetsUrl'
  ],

  data() {
    return {
      assetSelection: {},
      bulkActionRunning: false,
      assetPreviewId: this.collection.asset_preview_id
    }
  },

  methods: {

    assetKey(asset) {
      const idx = this.assets.indexOf(asset);
      return `${asset.id}-${idx}-${asset.updated_at}`
    },

    backgroundImage(asset) {
      return `background-image: url(${asset.thumb_url})`
    },

    handleAssetClick(asset) {
      this.$refs.modalNavigation.modalAsset = asset;
    },

    handleAssetSelection(file) {
      this.$set(this.assetSelection, file.id, !this.assetSelection[file.id]);
    },

    handleAddAssets(collection) {
      this.updateCollectionAssets(collection)
    },

    handleRemoveAssetsFromCollection() {
      if (confirm("Are you sure you want to remove the selected assets from this collection?")) {
        const remainingIds = this.assets.filter(asset => !this.selectedAssetIds.includes(asset.id)).map(asset => asset.id);
        this.$http.patch(`${this.collectionsUrl}/${this.collection.id}`, {
          collection: {
            asset_ids: remainingIds
          }
        }).then(fulfill => {
          location.reload();
        }, rejected => {
          this.showErrorToast("There was an error while removing these assets")
        })
      }
    },

    updateAssetPreviewId(id) {
      if (!id) return;

      const prevAssetId = this.assetPreviewId
      this.assetPreviewId = id

      this.$http.patch(`${this.collectionsUrl}/${this.collection.id}`, {
        collection: {
          asset_preview_id: id
        }
      }).then(fulfill => {}, rejected => {
        this.showErrorToast("There was an error while setting the asset preview")
        this.assetPreviewId = prevAssetId
      })
    }
  },

  computed: {
    selectedAssets() {
      if (this.selectedAssetIds.length > 0) {
        return this.selectedAssetIds.map(assetId => {
          return this.assets.find(asset => asset.id === assetId)
        })
      }
      return [];
    },

    assetPreview() {
      return this.assets.find(asset => asset.id === this.assetPreviewId)
    },

    selectedAssetsCount() {
      return this.selectedAssets.length;
    },

    selectedAssetIds: function () {
      return Object.keys(this.assetSelection).filter(key => this.assetSelection[key] === true);
    },
  },

  mixins: [GeneralMixins, CollectionMixins],
  components: {
    MoveToCollection,
    CollectionDropdown,
    BulkSelectionBar,
    ModalNavigation
  }
}
</script>